export const home = {
  nav: {
    features: 'Features',
    pricing: 'Pricing',
    testimonials: 'Testimonials',
    dashboard: 'Dashboard',
  },
  hero: {
    badge: 'AI-powered Nutrition Coach',
    title: 'Your personal',
    titleHighlight: 'Nutrition Coach',
    subtitle: 'AI-powered nutrition plans, personalized recipes and smart shopping lists for your health goals',
    dashboardAlt: 'NutriBot Dashboard Preview',
    ctaGetStarted: 'Get Started',
    ctaLearnMore: 'Learn More',
    ctaRegister: 'Get Started',
    ctaLogin: 'Sign In',
    stats: {
      satisfaction: '97%',
      satisfactionLabel: 'Satisfaction',
      users: '10k+',
      usersLabel: 'Users',
      plans: '30',
      plansLabel: 'Day Plans',
    },
  },
  features: {
    title: 'Revolutionary Features',
    subtitle: 'Experience the future of nutrition planning with cutting-edge AI technology and a personalized approach.',
    aiPersonalization: {
      title: 'AI-Powered Personalization',
      description: 'Advanced algorithms create nutrition plans tailored to your unique goals, preferences and dietary restrictions.',
    },
    chatbot: {
      title: '24/7 NutriBot Assistant',
      description: 'Get instant answers, plan adjustments and nutrition advice anytime from our intelligent chatbot.',
    },
    pdfReports: {
      title: 'Professional PDF Reports',
      description: 'Receive detailed nutrition reports with shopping lists, meal prep guides and progress tracking.',
    },
    mealPlans: {
      title: '30-Day Nutrition Plans',
      description: 'Complete 30-day plans with breakfast, lunch, dinner, ingredients and calories for every day.',
    },
    customization: {
      title: 'Individual Customization',
      description: 'Considers allergies, intolerances, diet type, culture and personal preferences for maximum satisfaction.',
    },
    tracking: {
      title: 'Progress Tracking',
      description: 'Track your health journey with detailed analytics and personalized recommendations.',
    },
  },
  pricing: {
    title: 'Flexible Pricing for Every Need',
    subtitle: 'Choose the plan that best fits your goals. Every plan is transparent and offers real value.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    yearlyDiscount: '-20%',
    yearlyBadge: '20% discount with annual payment',
    perMonth: 'per month',
    perYear: 'per year',
    basic: {
      name: 'Basic Plan',
      description: 'Perfect for getting started with personalized nutrition.',
      monthlyPrice: 'CHF 14.90',
      yearlyPrice: 'CHF 142.56',
      yearlyOriginal: 'CHF 178.80',
      yearlySavings: 'You save CHF 36.24',
      features: {
        1: 'Static nutrition plans',
        2: 'Basic features',
        3: 'Calories & ingredients per day',
        4: 'Considers allergies & preferences',
      },
      notIncluded: {
        1: 'No access to NutriBot',
        2: 'No real-time adjustments',
        3: 'No shopping lists',
      },
      cta: 'Choose Basic',
    },
    vip: {
      name: 'VIP Plan',
      badge: 'RECOMMENDED',
      description: 'Complete nutrition solution with unlimited possibilities.',
      monthlyPrice: 'CHF 29.90',
      yearlyPrice: 'CHF 287.04',
      yearlyOriginal: 'CHF 358.80',
      yearlySavings: 'You save CHF 71.76',
      features: {
        1: 'Full access to NutriBot',
        2: 'Weekly VIP recipes',
        3: 'Smart shopping lists',
        4: 'Real-time plan adjustments',
        5: 'Motivation & coaching content',
        6: 'PDF export for all plans',
        7: 'Dashboard with progress',
        8: '24/7 NutriBot chat assistant',
      },
      cta: 'Choose VIP',
    },
  },
  testimonials: {
    title: 'Testimonials from Our Users',
    subtitle: 'Real results, real motivation. Our community achieves their goals with personalized support.',
    user1: {
      name: 'Anna Müller',
      location: 'Zurich, Switzerland',
      plan: 'VIP Plan',
      text: 'I lost 8 kg healthily in 3 months and feel energized. The personalized plans are a game-changer!',
      stats: 'Before: 74 kg • After: 66 kg',
    },
    user2: {
      name: 'Marco Rossi',
      location: 'Basel, Switzerland',
      plan: 'VIP Plan',
      text: 'As a marathon runner, NutriBot gives me exactly the macros I need. The weekly updates keep me on track.',
      stats: 'Muscle gain: +3kg in 2 months',
    },
    user3: {
      name: 'Julia Weber',
      location: 'Bern, Switzerland',
      plan: 'VIP Plan',
      text: 'I finally have a nutrition plan that fits my daily life. The PDFs with shopping lists save me time every week.',
      stats: 'More energy • Better digestion',
    },
    stats: {
      satisfaction: '97%',
      satisfactionLabel: 'Customer satisfaction',
      adherence: '89%',
      adherenceLabel: 'Average plan adherence',
      recommendation: '92%',
      recommendationLabel: 'Recommendation rate',
    },
  },
  footer: {
    description: 'Improve your health with AI-powered, personalized nutrition plans.',
    product: {
      title: 'Product',
      features: 'Features',
      pricing: 'Pricing',
      dashboard: 'Dashboard',
    },
    company: {
      title: 'Company',
      about: 'About us',
      contact: 'Contact',
      privacy: 'Privacy',
    },
    support: {
      title: 'Support',
      help: 'Help Center',
      faq: 'FAQ',
    },
    copyright: '© 2026 NutriBot. All rights reserved.',
    poweredBy: 'Powered by Readdy',
  },
};
